<template>
  <!-- <el-scrollbar style="height: 100%; "> -->
    <div class="card-form-box" :style="mainBg">
      <div
        class="card-form-item"
        v-for="(item, index) in fieldList"
        :key="index"
        :style="{
          width: item.w + 'px',
          height: item.isAutoHeight && item.type !== 'customizeButton' ? '' : item.h + 'px',
          maxHeight: item.maxHeight ? item.maxHeight + 'px' : 'none',
          minHeight: item.maxHeight !== undefined ? item.h + 'px' : '',
          left: item.x + 'px',
          top: item.y + 'px',
          overflowY: getOverflowVal(item),
          overflowX: 'hidden',
          background: ['customizeImg', 'customizeIcon', 'customizeButton', 'customizeTag'].includes(item.type) ? 'none' : item.backgroundColor,
        }">
        <customizeImg v-if="item.type === 'customizeImg'" :config="item" />
        <customizeIcon v-else-if="item.type === 'customizeIcon'" :config="item" />
        <customizeText v-else-if="item.type === 'customizeTxt'" :config="item" />
        <!-- 通知对象 -->
        <comment 
          v-else-if="item.type === 'inform'"
          :config="item"
          :commentData="commentData"
          @changeTop="changeItemTop"
          @lookUp="(e)=>{$emit('lookUp', e)}"
          />
        <!-- 标签控件 -->
        <wusiLabel
          v-else-if="item.type === 'label'"
          :config="item"
          :name="item.name"/>
        <!-- 按钮组件 -->
        <btncomp
          v-else-if="item.type === 'customizeButton'"
          :info="item"
          :multipleSelection="[tableData]"
          :tableData="tableData"
          :approvalId="Number(cardConfig.dataSource.appid)"
          :screenRef="screenRef"
          isCard
          @buttonCilck="buttonCilck"
          @appPrint="(val) => { $emit('appPrint', val) }"
          @edit-btn="$emit('edit-btn')" 
          @open-login="$emit('open-login', $event)"
          @edit-user-info="val => { $emit('edit-user-info', val, tableData) }"
          @del-btn="$emit('del-btn')" 
          @open-appDialog="val => { $emit('open-appDialog', val) }"
          @blockchain-btn="$emit('blockchain-btn')"
          @dataArchiving-btn="$emit('dataArchiving-btn')"
          @openAppInitiate="val => { $emit('openAppInitiate', val) }"
          @custom-scene="val => { $emit('custom-scene', val) }"
          @todo-inside="$emit('todo-inside', {row: this.tableData, insideInfo: $event})"
        ></btncomp>
        <!-- 多选框 -->
        <checkbox
          v-else-if="item.type === 'checkbox'"
          @changeTop="changeItemTop"
          :name="item.name"
          :value="getValue(item)"
          :config="item" />
        <!-- 联系人 -->
        <relationUser
          v-else-if="item.type === 'relation-user'"
          @changeTop="changeItemTop"
          :name="item.name"
          :value="getValue(item)"
          :config="item" />
        <!-- 图片组件 -->
        <wusi-image
          v-else-if="item.type === 'image'"
          :name="item.name"
          :config="item"
          :value="getValue(item)"
        />
        <!-- 文件附件 -->
        <wusi-file
          v-else-if="item.type === 'file'"
          @changeTop="changeItemTop"
          :name="item.name"
          :config="item"
          :value="dealval(getValue(item))"
          :templateConfig="item"
        />
        <!-- 自定义标签 -->
        <template v-else-if="item.type === 'customizeTag'">
          <customTag :isCard="true" :info="item" v-if="isAppenTag(item)" />
        </template>
        <!-- 查询控件 -->
        <wusi-query
          v-else-if="item.type === 'query'"
          :config="item"
          :valueStyle="item.selsColor ? item.selsItemColor : ''"
          :value="getValue(item)"
          :formdata="tableData"
          :radioSels="typeof item.sels === 'string' ? JSON.parse(item.sels) : item.sels"
        />
        <!-- 单选关联 -->
        <wusi-new-rel-radio
          v-else-if="item.type === 'new-rel-radio'"
          :config="item"
          :ruleListChild="item"
          :formdata="tableData"
          :value="getValue(item)"
        />
        <!-- 明细控件 -->
        <wusi-details
          v-else-if="item.type === 'details'"
          :config="item"
          :detailsWidgetData="item.list"
          :value="getValue(item)"
        />
        <!-- 预约控件 -->
        <wusi-ready-widget
          v-else-if="item.type === 'ready-widget'"
          :config="item"
          :value="getValue(item)"
          :ruleListChild="item"
        />
        <!-- 常用的一般控件 -->
        <cardFormItem
          v-else
          :ref="item.title"
          @changeTop="changeItemTop"
          :config="item"
          :listTodoConfig="listTodoConfig"
          :approvingId="tableData.approvingId"
          :tableData="tableData"
          :approvalId="cardConfig.dataSource.appid"
          :name="item.name"
          :value="getValue(item)"
          />
      </div>
    </div>
  <!-- </el-scrollbar> -->
</template>

<script>
import DealPrintData from '@/components/common/detailEdit/utils/dealPrintData.utils.js'
import { isConditionAppen } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { cloneDeep } from 'lodash'
import { defineAsyncComponent } from 'vue'

export default {
  name: 'cardForm',
  data () {
    return {
      cardWidth: '',
      syllabel: [],
      // 下面两字字段辅助分辨率变化的数据
      screenWidth: '',
      screenHeight: '',
      tableData: {},
      pageConfig: {},
      token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : '',
    }
  },
  props: {
    cardConfig: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 列表的信息
    listInfo:{
      type:Object,
      default: ()=>{
        return {}
      }
    },
    data:{
      type: Object,
      default: () => {
        return {}
      }
    },
    commentData: {
      type: Object,
      default: () => {}
    },
    listTodoConfig:{
      type: Array,
      default: () => ([])
    },
    isAppenTag:{
      type: Function,
    },
    customDeskId: {
      type: [String, Number],
      default: 0
    },
    screenRef: {
      type: Array,
      default: ()=>([])
    },
    // 是否获取其他表的数据
    isGetOtherData: {
      type: Boolean,
      default: true
    },
    // 是否是移动端
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  components:{
    cardFormItem: defineAsyncComponent(()=>import('./cardFormItem.vue')),
    relationUser: defineAsyncComponent(()=>import('./relationUser.vue')),
    checkbox: defineAsyncComponent(()=>import('./checkbox.vue')),
    customizeImg: defineAsyncComponent(() => import('./customize/img.vue')),
    customizeIcon: defineAsyncComponent(() => import('./customize/icon.vue')),
    customizeText: defineAsyncComponent(() => import('./customize/text.vue')),
    customTag: defineAsyncComponent(()=> import('@/components/schoolInstrument/component/mutual/component/screen/lTag.vue')),
    btncomp: defineAsyncComponent(() => import('@/components/schoolInstrument/component/mutual/component/button/index.vue')),
    comment: defineAsyncComponent(() => import('./components/comment.vue')),
    wusiQuery: defineAsyncComponent(() => import('./components/query.vue')),
    wusiLabel: defineAsyncComponent(() => import('./components/label.vue')),
    wusiNewRelRadio: defineAsyncComponent(()=>import('./components/newRelRadio.vue')),
    wusiDetails: defineAsyncComponent(()=>import('./components/details.vue')),
		wusiReadyWidget: defineAsyncComponent(()=>import('./components/readyWidget.vue')),
    // imageComp: () => import('@/components/common/detailEdit/widget/image.vue'),
    wusiImage: defineAsyncComponent(() => import('./components/image.vue')),
    wusiFile: defineAsyncComponent(() => import('./components/file.vue')),
  },
  computed:{
    active () {
      let index = 0
      if (JSON.stringify(this.cardConfig) !== '{}') {
        index = this.cardConfig.activeConfig
      }
      return index
    },
    // 其他表的配置
    formList () {
      let formList = []
      if (this.cardConfig.dataSource && this.cardConfig.dataSource.formList && this.cardConfig.dataSource.formList.length > 0) {
        formList = this.cardConfig.dataSource.formList
      }
      return formList
    },
    mainBg () {
      let obj = {}
      if (this.pageConfig.configList) {
        const config = this.pageConfig.configList[this.active]
        obj = {
          width: this.isMobile ? '100%' : config.canvasWidth + 'px',
          height: config.canvasHeight + 'px',
          boxShadow: config.shadow ? 'rgb(201, 201, 201) 1px 1px 5px' : ''
        }
        if (config.backgroundValue === 0) {
          obj.backgroundColor = config.backgroundColor
        } else {
          obj.backgroundImage = `url('${this.$apiurl}${config.backgroundImage}')`
          obj.backgroundRepeat = 'no-repeat'
          obj.backgroundSize = '100% 100%'
          obj.opacity = config.percentage / 100
        }
      }
      return obj
    },
    customData () {
      return this.$store.state.doorCustomDataObj[this.customDeskId] || undefined
    },
    // 显示的字段
    fieldList() {
      return this.pageConfig
      && this.pageConfig.configList
      && this.pageConfig.configList[this.active]
      && this.pageConfig.configList[this.active].children
      && Array.isArray(this.pageConfig.configList[this.active].children)
      && this.pageConfig.configList[this.active].children.filter(item => {
        let isView = true
        if (item.condition && item.condition.linked && item.condition.linked.length > 0) {
          isView = isConditionAppen(item.condition, this.data, true, this.customData)
        }
        return isView
      })
    },
    targetItem () {
      const item = this.fieldList.filter(item => { return item.type === 'target' })
      return item.length > 0 ? item[0] : null
    }
  },
  watch: {
    data: {
      async handler (val) {
        if (JSON.stringify(val) !== '{}') {
          this.tableData = cloneDeep(val)
          if (this.isGetOtherData && this.formList.length > 0) {
            const { otherData } = await DealPrintData.getOtherApproval(this.cardConfig, cloneDeep(val))
            const resKey = Object.keys(otherData)
            resKey.forEach(key => {
              for (const itemKey in otherData[key]) {
                otherData[key][itemKey] = otherData[key][itemKey][0]
              }
              this.tableData = { ...this.tableData, ...otherData[key] }
            })
            this.tableData = await DealPrintData.getRelationUserInfo(this.tableData)
          }
        }
      },
      deep: true,
      immediate: true
    },
    cardConfig: {
      handler (val) {
        if (val && JSON.stringify(val) !== '{}') {
          this.pageConfig = JSON.parse(JSON.stringify(val))
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    buttonCilck () {
      if (this.targetItem) {
        const opt = { type: 'read', todo: 'add' }
        // skeyadd
        if (this.$refs[this.targetItem.title] &&
          this.$refs[this.targetItem.title][0] &&
          this.$refs[this.targetItem.title][0].$refs.detailCountRef) {
          this.$refs[this.targetItem.title][0].$refs.detailCountRef.addCount(opt)
        }
      }
    },
    getValue (item) {
      return this.tableData[item.title] || this.tableData[item.title + '_' + item.type] || this.tableData[item.name]
    },
    dealval (val) {
      return val ? (Array.isArray(val) ? val : JSON.parse(val)) : []
    },
    getOverflowVal (item) {
      if (item && item.type.search('customize') !== -1)  return 'hidden'
      let val = 'auto'
      if (item.contentOutside === 1) {
        val = 'hidden'
      } else {
        if (item.exceedType !== undefined) {
          if (item.exceedType === 0 || item.exceedType === 2) {
            val = 'hidden'
          } else if (item.exceedType === 1) {
            val = 'auto'
          }
        } 
      }
      return val
    },
    changeItemTop ({ item, differHeight }) {
      const activeIndex = this.pageConfig.activeConfig
      this.pageConfig.configList[activeIndex].canvasHeight += differHeight
      for(const key in this.pageConfig.configList[activeIndex].children) {
        const iter = this.pageConfig.configList[activeIndex].children[key]
        if (iter.y > item.y) {
          iter.y += differHeight
          iter.differHeight += differHeight
        }
      }
    },
  }
}
</script>
<style lang='scss' scoped>
.card-form-box {
  position: relative;
  overflow: hidden;
  .card-form-item {
    position: absolute;
    z-index: 1;
  }
}
:deep(.card-form-item .btn-popover) {
  width: 100%;
  height: 100%;
}
.card-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  .card {
    width: 262px;
    height: 262px;
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;
    .bottom-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .card-item {
      display: flex;
      font-size: 14px;
      .card-item-one {
        position: relative;
        z-index: 2;
      }
    }
  }
}
:deep(.el-card__body) {
  padding: 0;
}
:deep(.el-scrollbar) {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
:deep(.expand-btn) {
	position: absolute;
	right: 0;
	bottom: 0;
	cursor: pointer;
	color: #4e86ff;
}
</style>
